<script lang="ts">
  import { t } from 'svelte-i18n';

  type ValueItem = { title: string, icon: string, description: string };
  let list: boolean[] = [true, false, false, false, false];

  const valuesList: ValueItem[] = [
    {
      title: 'ABOUT.VALUES.SLIDE1_TITLE',
      description: 'ABOUT.VALUES.SLIDE1_DESCRIPTION',
      icon: 'images/about-list-icon-1.svg',
    },
    {
      title: 'ABOUT.VALUES.SLIDE2_TITLE',
      description: 'ABOUT.VALUES.SLIDE2_DESCRIPTION',
      icon: 'images/about-list-icon-2.svg',
    },
    {
      title: 'ABOUT.VALUES.SLIDE3_TITLE',
      description: 'ABOUT.VALUES.SLIDE3_DESCRIPTION',
      icon: 'images/about-list-icon-3.svg',
    },
    {
      title: 'ABOUT.VALUES.SLIDE4_TITLE',
      description: 'ABOUT.VALUES.SLIDE4_DESCRIPTION',
      icon: 'images/about-list-icon-4.svg',
    },
    {
      title: 'ABOUT.VALUES.SLIDE5_TITLE',
      description: 'ABOUT.VALUES.SLIDE5_DESCRIPTION',
      icon: 'images/about-list-icon-5.svg',
    },
  ]

  function handleOpen(index: number) {

    list = list.map((value, i) => {
      if (index === i) {
        return true;
      }

      return false;
    })

    list[index] = true;
  }
</script>

<div class="c-about-list">
  {#each valuesList as value, i}
    <article on:click={() => handleOpen(i)} class="c-about-list__item transition-width duration-[195ms] { list[i] ? 'lg:flex-1' : 'lg:w-[206px]' } 
      { i === list.length - 1 ? 'border-b border-t lg:border-r lg:border-l lg:border-b-0 lg:border-t-0' : ' ' }">
      <div class="flex items-center c-about-list__header lg:flex-col lg:justify-between lg:items-start lg:h-full transition-height duration-[195ms] {list[i] ? 'c-about-list__item-header--active' : '' }">
        <img class="max-h-[26px] mr-3" src={value.icon} alt={$t(value.title)}>
        <p class="text-black leading-[1.75] text-base lg:text-base p-0 lg:pt-6 lg:pb-3 selection-light">{$t(value.title)}</p>
        <ion-icon class="lg:hidden ml-auto text-md text-strong-gray" name={list[i] ? 'chevron-up-sharp' : 'chevron-down-sharp' }></ion-icon>
      </div>

      <div class="pointer-events-none c-about-list__description  {list[i] ? 'c-about-list__description--active' : '' } ">
        <p class="text-opaque-black selection-light pb-0 pt-4 lg:pt-0">{$t(value.description)}</p>        
      </div>
    </article>
  {/each}
</div>

<style lang="postcss">
  .c-about-list {
    @apply flex flex-col lg:flex-row md2:mt-[-64px] lg:mt-[-72px] xl:mt-[-80px] mb-8 md:mb-12 md2:mb-16 lg:mb-[72px] lg:px-12 xl:px-[calc(50vw-638px)] lg:border-b lg:border-t lg:border-medium-gray;
  }

  .c-about-list__description {
    max-height: 0px;
    height: 100%;
    opacity: 0;

    transition: max-height 195ms ease-in, opacity 195ms ease-in-out;
  }

  .c-about-list__description--active {
    max-height: 205px;
    opacity: 1;
    pointer-events: all;
  }

    @media screen and (min-width: 1601px) { 
      .c-about-list__description {
        min-width: 400px;
        height: auto;
      }

      .c-about-list__description--active {
        max-height: 230px;
        overflow: hidden;
        height: fit-content;
      }

      .c-about-list__header {
        flex-basis: 100%;
        transition: flex-basis 195ms ease-in-out;
      }

      .c-about-list__item-header--active {
        flex-basis: 90px;
      }
    
    }


  .c-about-list__item {
    @apply overflow-hidden;
    @apply flex flex-col justify-start border-medium-gray;
    @apply px-12 py-12 xs:px-[72px] lg:px-40 lg:px-44 lg:px-6 lg:pt-6 lg:pb-8;
    @apply lg:min-h-[340px] xl:min-h-[380px];
    @apply cursor-pointer active:bg-none;
    @apply lg:border-l border-t lg:border-b-0 lg:border-t-0;
  }
</style>